import styled from 'styled-components';

import { color } from '../../styles_js/variables';

export const TitleSt = styled.div`
  display: flex;
  align-items: center;
`;

export const LogoSt = styled.a`
  & > svg {
    height: 24px;
    width: 76px;
  }

  .logo-letter {
    fill: #fff;
  }

  .logo-line {
    fill: ${color.brandPrimary};
  }
`;

export const TitleDealerPortal = styled.div`
  position: absolute;
  bottom: 25%;
  left: 100%;
  padding-left: 20px;
  font-size: 16px;
  color: #fff;
`;

export const TitleTextSt = styled.div`
  display: none;
  margin: 0 0 0 8px;
  font-size: 28px;
  line-height: 1.71;
  font-weight: normal;
  letter-spacing: 0.2px;
  color: ${color.white};
  text-transform: initial;
`;
